import React from 'react';
//import ReactDOM from 'react-dom';
import { createRoot } from 'react-dom/client';
import * as Sentry from '@sentry/react';
import { initSentry } from './services/sentry';
import './index.css';
import i18n from './i18n';
import App from './pages/App';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import reportWebVitals from './reportWebVitals';

//Importing the Bootstrap CSS
import 'bootstrap/dist/css/bootstrap.min.css';

//Shell.css — tokens globais (--ink-*, --teal-*, --paper, --bs-* overrides).
//Antes só carregava em rotas privadas (via MainPage/Sidebar), o que deixava as
//telas de auth (login/forgot/reset/invite) sem tokens — botão Bootstrap ficava
//azul default, borda/radius default etc. Import global resolve. Regras de
//layout do shell (.app/.side/.main) são inertes fora do contexto autenticado.
import './styles/Shell.css';

//Tema global de modais — sobrescreve bootstrap defaults (header/footer/botões/inputs)
//pra alinhar TODOS os Modais ao padrão gabarito/ConfirmDialog. Importado DEPOIS do
//bootstrap.min.css pra vencer a cascata.
import './styles/Modal.css';

//FormField.css — dono dos átomos `.ff-*` emitidos pelo componente <FormField>.
//Estilo de campo (label + input + hint + erro) vive AQUI, não nas telas.
//Padding 10px 12px do input mora aqui (Bootstrap default é 6px 12px).
import './styles/FormField.css';

//Form.css — átomos `.fg-*` (gabarito de form: card/tabs/pane/foot + botões
//fg-btn-cancel/fg-btn-save + hint/err). Global porque qualquer modal ou tela
//pode consumir os botões — antes só SaveSchool/SaveUser importavam, então
//UpdatePasswordModal aberto do topbar renderizava Cancelar teal (Bootstrap default).
import './styles/Form.css';

//Auth shell — átomos específicos das 6 telas de auth (login, forgot, reset, invite,
//link-sent, link-expired). Só átomos que não são do FormField (título, link,
//result icon, checklist, container). Ver REDLINE-auth.md.
import './styles/Auth.css';

//Feedback system (REDLINE-feedback.md): Toast (§3), ConfirmDialog (§4),
//InlineError (§5) + PageBanner (§7). Todos importados global — a árvore
//já usa via useToast()/InlineError/PageBanner/ConfirmDialog em qualquer nível.
import './styles/Toast.css';
import './styles/ConfirmDialog.css';
import './styles/Feedback.css';

//Loading system (REDLINE-loading.md): primitivos .sk (shimmer) + .spin (spinner
//localizado). Layout de skeleton (grid, gap, padding) vive nos CSS das
//superfícies (DataTable, Panel, FormGrid) — aqui só cor/raio/animação.
import './styles/LoadingSystem.css';

//Importing the Fontawesome CSS
import 'font-awesome/css/font-awesome.css';

// Sentry init ANTES de qualquer render — sem DSN pula silenciosamente.
initSentry();

//Strict Mode is usefull during development and it does not apply in production
//ReactDOM.render(<React.StrictMode><App /></React.StrictMode>, document.getElementById('root'));

const container = document.getElementById('root');
const root = createRoot(container); // createRoot(container!) if you use TypeScript
// `Sentry.ErrorBoundary` captura render errors da árvore inteira; sem DSN o
// SDK vira no-op mas o boundary segue mostrando o fallback pra evitar tela branca.
root.render(
  <React.StrictMode>
    <Sentry.ErrorBoundary fallback={<div style={{ padding: 24 }}>Algo deu errado. Recarregue a página.</div>}>
      <App />
    </Sentry.ErrorBoundary>
  </React.StrictMode>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.unregister();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
